module.exports = __webpack_public_path__ + "static/media/qr-code-icon.77d504b4.svg";